import CartLines, { CartLinesStyles, cartLinesStyles } from "@insite/content-library/Widgets/Cart/CartLines";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartLinesStyles.headerWrapper = {
    css: css`
        display: flex;
        align-items: center;
        border-bottom: none;
        padding-bottom: 10px;
    `,
};
